<script lang="ts">
  let id = (Math.round(Math.random() * 1000000)).toString();
  let value: boolean;
  let label: string = "";
  let fontSize: "xxs" | "xs" | "md" | "xl" | "xxl" = "md";

  export { value, label, fontSize };
</script>

<div class="flex items-center">
  <input
    {id}
    type="checkbox"
    bind:checked={value}
    on:change|stopPropagation
    class="w-4 h-4 accent-primary-500"
  />
  {#if label !== ""}
    <label
      for={id}
      class="grow ml-2 text-{fontSize} font-medium text-gray-900 dark:text-gray-300"
    >
      {label}
    </label>
  {/if}
</div>
